<template>
  <div>
    <ul>
      <li v-for="data in dataDummy" :key="data.id" class="li-active">
        <div :class="{ 'squnce-process': data.id == dataSquence.id, 'squnce-active': data.id < dataSquence.id }">
          {{ data.id }}
        </div>
        <span>{{ data.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    dataSquence: Object,
  },

  data() {
    return {
      dataDummy: [
        { id: 1, title: "profil perusahaan" },
        { id: 2, title: "simulasi" },
        { id: 3, title: "pengalaman investasi" },
        { id: 4, title: "data pribadi" },
        { id: 5, title: "kontak darurat" },
        { id: 6, title: "pekerjaan" },
        { id: 7, title: "keuangan" },
        { id: 8, title: "rekening" },
        { id: 9, title: "lampiran" },
        { id: 10, title: "resiko" },
        { id: 11, title: "amanat" },
        { id: 12, title: "kode akses" },
      ],
      squenceActive: false,
      squenceProsess: false,
    };
  },
  mounted() {
    if (this.dataSquence.id < this.dataDummy.length) {
      this.squenceActive = true;
    }
    for (let i = 0; i < this.dataDummy.length; i++) {
      if (this.dataDummy[i].id == this.dataSquence.id) {
        this.squenceProsess = true;
      }
    }
  },
};
</script>

<style scoped>
.top-squence {
  width: 85%;
  border-radius: 10px 10px 0 0;
  margin: 0 auto;
  background: #000e22;
  padding: 29px 20px;
  font-size: 14px;
}

ul {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

ul li {
  list-style: none;
  text-align: center;
  font-size: 10px;
  color: #40688e;
  position: relative;
  width: 91px;
}

ul li div {
  background: transparent;
  border: solid 0.1px #40688e;
  color: #40688e;
  border-radius: 50%;
  width: 27px;
  font-size: 16px;
  font-weight: 600;
  margin: 2px auto;
}

.li-active {
  color: #c59733;
}

ul li span,
.li-active span {
  display: none;
}

ul li div.squnce-active {
  position: relative;
  background: #c59733;
  color: #000e22;
  border: solid 0.5px #c59733;
}

ul li div.squnce-process {
  position: relative;
  border: solid 0.5px #c59733;
  color: #c59733;
}
</style>
